import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Login } from "../Login";
import { EmailSentNotice } from "../EmailSentNotice";
import { Notice } from "../../../common/cards/Notice";
import {
  clearAuthModalLinkSent,
  closeAuthModal,
  getAuthModalState,
  markAuthModalLinkSent,
  subscribeToAuthModalState,
} from "../../../../helpers/authModalHelpers";
import "./LoginModal.scss";

export function LoginModal() {
  const [{ isOpen, config, version, sentEmail }, setState] = useState(getAuthModalState());
  const [isSending, setIsSending] = useState(false);

  useEffect(() => subscribeToAuthModalState(() => setState(getAuthModalState())), []);

  const handleClose = () => {
    if (isSending) return;
    closeAuthModal();
  };

  const handleSent = (email: string) => {
    setIsSending(false);
    markAuthModalLinkSent(email);
    config.onSent?.();
  };

  return (
    <Modal
      show={isOpen}
      onHide={handleClose}
      backdrop={isSending ? "static" : true}
      keyboard={!isSending}
      dialogClassName="auth-modal-dialog"
      className="login-modal-root"
      backdropClassName="login-modal-backdrop"
    >
      <div className="d-flex justify-content-end p-4 pb-0">
        <button
          type="button"
          className="btn btn-icon btn-sm btn-active-light-primary text-dark"
          aria-label="Close"
          onClick={handleClose}
          disabled={isSending}
        >
          <i className="bi bi-x-lg fs-3"></i>
        </button>
      </div>

      <div className="px-8 px-md-10 pb-8 pb-md-10 pt-0">
        {sentEmail ? (
          <EmailSentNotice email={sentEmail} onResend={clearAuthModalLinkSent} />
        ) : (
          <Login
            key={version}
            bare
            initialEmail={config.email}
            autoSubmit={config.initialStatus === "sending"}
            redirectPath={config.redirectPath}
            onSent={handleSent}
            onSignUpClick={handleClose}
            onLoadingChange={setIsSending}
            notice={
              config.tagline ? (
                <Notice
                  noticeClasses="notice d-flex bg-light-warning rounded border-warning border-dashed p-6"
                  button={null}
                  header={null}
                  content={config.tagline}
                  icon={null}
                  iconClasses={null}
                  centerText={true}
                />
              ) : undefined
            }
          />
        )}
      </div>
    </Modal>
  );
}
